import { render, staticRenderFns } from "./LeadList.vue?vue&type=template&id=61b0f7c2&scoped=true"
import script from "./LeadList.vue?vue&type=script&lang=js"
export * from "./LeadList.vue?vue&type=script&lang=js"
import style0 from "./LeadList.vue?vue&type=style&index=0&id=61b0f7c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b0f7c2",
  null
  
)

export default component.exports